import { Injectable } from '@angular/core';
import { APIHttpService } from './api-http.service';
import { IInsurersDetails, IOccupations, SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import { Observable } from 'rxjs';
import { ICtrlResponse } from '../interfaces/api.interface';

@Injectable({
  providedIn: 'root',
})
export class APIMetaService {
  constructor(private readonly ctrlHttp: APIHttpService) {}

  searchOccupation(occupation: string): Observable<ICtrlResponse<IOccupations>> {
    return this.ctrlHttp.post(`/occupation/search/${occupation}/`, {});
  }

  async sendToCallCenter(payload: any): Promise<Observable<ICtrlResponse<any>>> {
    return this.ctrlHttp.post('/external_leads/refer_to_call_center', {...payload})
  }

  async getActiveInsurerDetails(): Promise<Observable<ICtrlResponse<Array<IInsurersDetails>>>>{
    return this.ctrlHttp.get('/insurers/?active=true')
  }
}
